/**
 * Moon Energy — Header / Navbar JS
 * Mobile menu toggle
 */
(function () {
  'use strict';

  const hamburger = document.getElementById('hamburger-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const menuOverlay = document.getElementById('mobile-menu-overlay');
  const hamburgerLines = document.querySelectorAll('.hamburger-line');
  function openMenu() {
    if (mobileMenu) mobileMenu.classList.add('open');
    if (menuOverlay) menuOverlay.style.display = 'block';
    hamburgerLines.forEach(l => l.classList.add('open'));
  }

  function closeMenu() {
    if (mobileMenu) mobileMenu.classList.remove('open');
    if (menuOverlay) menuOverlay.style.display = 'none';
    hamburgerLines.forEach(l => l.classList.remove('open'));
  }

  if (hamburger) hamburger.addEventListener('click', () => {
    mobileMenu && mobileMenu.classList.contains('open') ? closeMenu() : openMenu();
  });

  if (mobileMenu) mobileMenu.addEventListener('click', function(e) {
    if (e.target === mobileMenu) closeMenu();
  });

  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  // Close menu on nav link click
  document.querySelectorAll('.mobile-nav-link').forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // Highlight active nav link
  function updateActiveNav() {
    const path = window.location.pathname;
    const hash = window.location.hash.toLowerCase();
    document.querySelectorAll('.nav-link, .mobile-nav-link').forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;
      link.classList.remove('active');
      if (href.indexOf('#') !== -1) {
        // Hash-routed links (e.g. /#about, /#contact) only apply on the home page.
        const hrefHash = href.slice(href.indexOf('#')).toLowerCase();
        if ((path === '/' || path === '') && hash === hrefHash) link.classList.add('active');
        return;
      }
      if (path === href) link.classList.add('active');
      if (href === '/collections' && path.startsWith('/collections') && !path.startsWith('/collections/all')) link.classList.add('active');
      if (href === '/collections/all' && path === '/collections/all') link.classList.add('active');
      if (href === '/pages/lookbook' && path === '/pages/lookbook') link.classList.add('active');
    });
  }

  updateActiveNav();
  window.addEventListener('hashchange', updateActiveNav);

})();
